import React from 'react';

import { CheckCircleOutline, ErrorOutline, RemoveCircleOutline } from '@mui/icons-material';
import { Chip, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  status: JSX.Element;
};

export default function StepTitle({ title, status }: Props) {
  return (
    <Stack
      mb={1}
      spacing={{ xs: 1, sm: 3 }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
    >
      <Typography variant="h5" component="h2">
        {title}
      </Typography>
      {status}
    </Stack>
  );
}

type StepTitleStatusProps = {
  status: 'SUCCEEDED' | 'PENDING' | 'FAILED' | 'LOADING';
  label: string;
};
export function StepTitleStatus({ label, status }: StepTitleStatusProps) {
  const renderIcon = () => {
    switch (status) {
      case 'SUCCEEDED':
        return <CheckCircleOutline fontSize="small" />;
      case 'FAILED':
        return <ErrorOutline fontSize="small" />;
      case 'PENDING':
        return <RemoveCircleOutline fontSize="small" />;
      case 'LOADING':
        return <RemoveCircleOutline fontSize="small" />;
    }
  };

  const getColor = () => {
    switch (status) {
      case 'SUCCEEDED':
        return 'success';
      case 'FAILED':
        return 'error';
      case 'PENDING':
      case 'LOADING':
        return 'default';
    }
  };

  return <Chip icon={renderIcon()} label={label} color={getColor()} />;
}
